import { CareInstitution, Department, MenuItem, Patient } from '@/models';
import { CareInstitutionService, DepartmentService, ErrorService, PatientService } from '@/services';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-patient-dialog',
  templateUrl: './change-patient-dialog.component.html',
  styleUrls: ['./change-patient-dialog.component.scss'],
  standalone: false,
})
export class ChangePatientDialogComponent implements OnInit {
  careInstitutions: CareInstitution[] = [];

  careInstitutionsLoading: boolean = false;
  departmentsLoading: boolean = false;
  patientsLoading: boolean = false;

  selectedCareInstitution?: CareInstitution;
  selectedDepartment?: Department;
  selectedPatientId: string;
  patientMenuItems: MenuItem[] = [];

  constructor(
    public dialogRef: MatDialogRef<ChangePatientDialogComponent>,
    private careInstitutionService: CareInstitutionService,
    private departmentService: DepartmentService,
    private patientService: PatientService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.careInstitutionService.getCareInstitutions().subscribe(
      resp => {
        this.careInstitutions = resp;
        this.careInstitutions.sort((a, b) => a.name.localeCompare(b.name));
      },
      err => this.errorService.onError(err)
    );
  }

  onCareInstitutionChange(event: { value: CareInstitution }) {
    this.selectedCareInstitution = undefined;
    this.selectedDepartment = undefined;
    this.selectedPatientId = '';
    this.departmentsLoading = true;
    this.patientMenuItems = [];
    this.careInstitutionService.getCareInstitutionById(event.value.id).subscribe(
      resp => {
        this.selectedCareInstitution = resp as CareInstitution;
        this.departmentsLoading = false;
        this.selectedCareInstitution.departments.sort((a, b) => a.name.localeCompare(b.name));
        for (let department of this.selectedCareInstitution.departments) {
          department.roles.sort((a, b) => a.name.localeCompare(b.name));
        }
      },
      err => this.errorService.onError(err)
    );
  }

  onDepartmentChange(event: { value: Department }) {
    this.patientsLoading = true;
    this.selectedDepartment = event.value;
    this.selectedPatientId = '';
    this.patientMenuItems = [];
    this.departmentService.getPatientsForDepartment(this.selectedDepartment.id).subscribe(
      resp => {
        this.patientMenuItems = resp.map(item => this.toMenuItem(item));
        this.patientsLoading = false;
        this.patientMenuItems.sort((a, b) => a.name.localeCompare(b.name));
      },
      err => this.errorService.onError(err)
    );
  }

  toMenuItem(item: Patient): MenuItem {
    return {
      id: item.id,
      name: this.getPatientProperty(item, 'zoeknaam'),
    };
  }

  selectPatient(patientId: string) {
    this.selectedPatientId = patientId;
  }

  getPatientProperty(patient: Patient, property: string): string {
    return patient.properties.find(x => x.property.name == property)?.value || '';
  }

  async edit() {
    if (!this.selectedPatientId) return;
    const { data } = await this.patientService.getPatientById(this.selectedPatientId, true);
    if (data) {
      const patient = data as unknown as Patient;
      patient.department.roles = this.selectedDepartment?.roles || [];
      this.dialogRef.close(patient);
    }
  }
}
